"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export type FaqArticleProps = BuilderComponentProps<typeof FaqArticleInputs>;

export const FaqArticleInputs = [
  {
    name: "question",
    type: "string",
    required: true,
    defaultValue: "What is Ploom Club?",
  },
  {
    name: "questionHeadlineType",
    type: "string",
    enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
    defaultValue: "h1",
    required: true,
  },
  {
    name: "answer",
    type: "richText",
    required: true,
    defaultValue:
      "Ploom Club is a subscription service that delivers your favorite Ploom products to your door every month.",
  },
  {
    name: "seoFriendlyAnswer",
    type: "longText",
  },
] as const satisfies Inputs;

const FaqArticle = dynamic(async () =>
  withValidation(
    FaqArticleInputs,
    (await import("./FaqArticle")).FaqArticle,
    "FaqArticle"
  )
);
export const FaqArticleComponent: RegisteredComponent = {
  name: "FaqArticle",
  component: FaqArticle,
  inputs: FaqArticleInputs,
};
